import "./index.sass";

const IntroMEF = () => {
  return (
    <div id="intro-mef">
      <div className="intro-mef-subtitle">Infosys at MWC 2025</div>
      <div className="intro-mef-title">AI @ Edge</div>
    </div>
  );
};

export default IntroMEF;
